import type { SectionsMigrationScope as Scope } from '../scope';
import * as stateManagement from '#packages/stateManagement';
import * as helpIds from '#packages/helpIds';
import {
  getMigrationSkipCount,
  HEAVY_SITES,
  isMigrationCancelled,
  isTimeLimitError,
  PER_PAGE_MIGRATION,
} from '../utils';
import { MigrationFlow } from '../types';
import { MIGRATION_SKIP_LIMIT, MigrationOrigin } from '../constants';

export function showNotification(
  scope: Scope,
  {
    messageType,
    message,
    link = HEAVY_SITES.NOTIFICATION_LEARN_MORE_LINK_TEXT,
    onClick = () =>
      scope.editorAPI.panelManager.openHelpCenter(
        helpIds.HEAVY_SITES_MIGRATION_HELP_IDS.LEARN_MORE,
      ),
  }: {
    messageType: 'error' | 'info' | 'success' | 'warning';
    message: string;
    link?: string;
    onClick?: () => void;
  },
) {
  scope.editorAPI.store.dispatch(
    stateManagement.notifications.actions.showUserActionNotification({
      message,
      link: {
        caption: link,
        onNotificationLinkClick: onClick,
      },
      type: messageType,
      timeout: 20000,
    }),
  );
}

export function showErrorNotification(
  scope: Scope,
  {
    flow,
    error,
    origin,
  }: {
    flow: MigrationFlow;
    error: Error;
    origin: MigrationOrigin;
  },
) {
  const perPageFlow =
    flow === MigrationFlow.PerPageEditor || flow === MigrationFlow.PerPageADI;

  const shouldShowErrorNotification =
    flow === MigrationFlow.Editor ||
    flow === MigrationFlow.HeavySite ||
    perPageFlow;

  if (!shouldShowErrorNotification) {
    return;
  }

  if (origin === MigrationOrigin.ExitPreview && perPageFlow) {
    showNotification(scope, {
      messageType: 'warning',
      message: PER_PAGE_MIGRATION.NOTIFICATION_ERROR_FROM_PREVIEW_TEXT,
      link: PER_PAGE_MIGRATION.NOTIFICATION_ERROR_FROM_PREVIEW_CTA,
      onClick: () => {
        scope.editorAPI.openPagesPanel({});
      },
    });

    return;
  }

  if (isTimeLimitError(error)) {
    showNotification(scope, {
      messageType: 'info',
      message: HEAVY_SITES.NOTIFICATION_TIME_OUT,
    });
  } else if (
    isMigrationCancelled(error) &&
    getMigrationSkipCount(scope) >= MIGRATION_SKIP_LIMIT
  ) {
    showNotification(scope, {
      messageType: 'info',
      message: HEAVY_SITES.NOTIFICATION_SKIPPED_THIRD,
    });
  } else if (!isMigrationCancelled(error) && !perPageFlow) {
    showNotification(scope, {
      messageType: 'error',
      message: HEAVY_SITES.NOTIFICATION_TECH_ERROR,
    });
  }
}
